exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sf-user-bubble[data-v-900df69e]{align-self:flex-end;max-width:280px;animation:sf-user-msg-appear-900df69e .25s cubic-bezier(.16,1,.3,1) both}.sf-user-bubble__text[data-v-900df69e]{background:#517b86;color:#fff;border-radius:10px 10px 0 10px;padding:12px 16px;font-size:15px;font-family:Comfortaa,sans-serif;line-height:1.5}@keyframes sf-user-msg-appear-900df69e{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}", ""]);

// exports
